module.exports = __webpack_public_path__ + "static/img/icon_heart.bc64a570.svg";